import fetchServices from "./FetchServices";
import ApiConstants from '../Utils/ApiConstant';
import { hideLoader, showLoader } from "../Store/Readux/Reducer/LoaderSlice";

export const loginUser = (requestBody) => async (dispatch) => {
    dispatch(showLoader());
    try {
        let URL = ApiConstants.loginUserURL;
        const method = "POST";
        const data = await fetchServices(URL, method, requestBody);
        return data;
    } catch (error) {
        console.log(error.message);
    } finally {
        dispatch(hideLoader());
    }
};

export const forgotPassword = (requestBody) => async (dispatch) => {
    dispatch(showLoader());
    try {
        let URL = ApiConstants.forgotPasswordURL;
        const method = "POST";
        const data = await fetchServices(URL, method, requestBody);
        return data;
    } catch (error) {
        console.log(error.message);
    } finally {
        dispatch(hideLoader());
    }
};

export const verifyResetToken = (requestBody) => async (dispatch) => {
    dispatch(showLoader());
    try {
        let URL = ApiConstants.verifyResetTokenURL;
        const method = "POST";
        const data = await fetchServices(URL, method, requestBody);
        return data;
    } catch (error) {
        console.log(error.message);
    } finally {
        dispatch(hideLoader());
    }
};

export const resetPassword = (requestBody) => async (dispatch) => {
    dispatch(showLoader());
    try {
        let URL = ApiConstants.resetPasswordURL;
        const method = "POST";
        const data = await fetchServices(URL, method, requestBody);
        return data;
    } catch (error) {
        console.log(error.message);
    } finally {
        dispatch(hideLoader());
    }
};
export const resendOtp = (requestBody) => async (dispatch) => {
    dispatch(showLoader());
    try {
        let URL = ApiConstants.resendOtpURL;
        const method = "POST";
        const data = await fetchServices(URL, method, requestBody);
        return data;
    } catch (error) {
        console.log(error.message);
    } finally {
        dispatch(hideLoader());
    }
};

export const otpVerification = (requestBody) => async (dispatch) => {
    dispatch(showLoader());
    try {
        let URL = ApiConstants.otpVerificationURL;
        const method = "POST";
        const data = await fetchServices(URL, method, requestBody);
        return data;
    } catch (error) {
        console.log(error.message);
    } finally {
        dispatch(hideLoader());
    }
};

export const Userlogout = () => async (dispatch) => {
    dispatch(showLoader());
    try {

        let URL = ApiConstants.logoutURL;
        const method = "GET";
        const data = await fetchServices(URL, method);
        return data;
    } catch (error) {
        console.log(error.message);
    } finally {
        dispatch(hideLoader());
    }
};